/**
 * 整体项目设置相关的 store
 */

import { setTheme } from "@/utils";
function toJSON(str) {
  if (typeof str === "string") {
    try {
      var obj = JSON.parse(str);
      if (typeof obj === "object" && obj) {
        return obj;
      } else {
        return {};
      }
    } catch (e) {
      console.log("toJSON error：" + str + "!!!" + e);
      return {};
    }
  } else {
    return {};
  }
}

const app = {
  state: {
    sidebar: {
      opened: localStorage.getItem("sidebarStatus") ? !!+localStorage.getItem("sidebarStatus") : true,
      withoutAnimation: false
    },
    device: "desktop",
    drawer: false,
    themeColor: localStorage.getItem("themeColor") || "",
    theme: localStorage.getItem("theme") || "blackgold",
    // themePicker: '',
    sex: [
      { value: false, label: "女" },
      { value: true, label: "男" }
    ],
    language: localStorage.getItem("language") || "zh",
    size: localStorage.getItem("size") || "medium",
    basicInfo: toJSON(localStorage.getItem("basicInfo")) // 系统信息
  },
  mutations: {
    TOGGLE_SIDEBAR: state => {
      state.sidebar.opened = !state.sidebar.opened;
      state.sidebar.withoutAnimation = false;
      if (state.sidebar.opened) {
        localStorage.setItem("sidebarStatus", 1);
      } else {
        localStorage.setItem("sidebarStatus", 0);
      }
    },
    CLOSE_SIDEBAR: (state, withoutAnimation) => {
      localStorage.setItem("sidebarStatus", 0);
      state.sidebar.opened = false;
      state.sidebar.withoutAnimation = withoutAnimation;
    },
    TOGGLE_DEVICE: (state, device) => {
      state.device = device;
    },
    TOGGLE_DRAWER: (state, opened = true) => {
      state.drawer = opened;
    },
    CHANGE_THEME: (state, theme = state.theme) => {
      localStorage.setItem("theme", theme);
      state.theme = theme;
      setTheme(theme);
    },
    CHANGE_THEME_COLOR: (state, color) => {
      localStorage.setItem("themeColor", color);
      state.themeColor = color;
    },
    SET_LANGUAGE: (state, language) => {
      state.language = language;
      localStorage.setItem("language", language);
    },
    SET_SIZE: (state, size) => {
      state.size = size;
      localStorage.setItem("size", size);
    },
    SET_BasicInfo: (state, basicInfo) => {
      state.basicInfo = basicInfo;
      localStorage.setItem("basicInfo", JSON.stringify(basicInfo));
    }
  },
  actions: {
    toggleSideBar({ commit }) {
      commit("TOGGLE_SIDEBAR");
    },
    closeSideBar({ commit }, { withoutAnimation }) {
      commit("CLOSE_SIDEBAR", withoutAnimation);
    },
    toggleDevice({ commit }, device) {
      commit("TOGGLE_DEVICE", device);
    },
    toggleDrawer({ commit }, opened) {
      commit("TOGGLE_DRAWER", opened);
    },
    changeTheme({ commit }, { theme }) {
      return commit("CHANGE_THEME", theme);
    },
    changeThemeColor({ commit }, color) {
      return commit("CHANGE_THEME_COLOR", color);
    },
    setLanguage({ commit }, language) {
      commit("SET_LANGUAGE", language);
    },
    setSize({ commit }, size) {
      commit("SET_SIZE", size);
    },
    setBasicInfo({ commit }, basicInfo) {
      commit("SET_BasicInfo", basicInfo);
    }
  }
};

export default app;
